import {setAjax, formatBytes} from "../../helpers";
import lightGallery from "lightgallery";
import lgZoom from 'lightgallery/plugins/zoom';
import lgVideo from 'lightgallery/plugins/video';

import simpleParallax from 'simple-parallax-js';

import 'animate.css';
import WOW from 'wow.js';
import mapboxgl from 'mapbox-gl/dist/mapbox-gl';

function openNav(navMob)
{
    navMob.addEventListener('click', ()=>{
        let btn = navMob.querySelector('button');
        let btnTxt = btn.querySelector('[data-txt]');
        let txt = btnTxt.dataset.txt;
        let oldTxt = btnTxt.textContent;

        btnTxt.textContent = txt;
        btnTxt.dataset.txt = oldTxt;
        navMob.classList.toggle('open');
        navMob.closest('header').querySelector('.nav').classList.toggle('open');
    })
}

function navigateSite(navLink)
{
    navLink.forEach((link)=>{
        link.addEventListener('click', ()=>{
            navLink.forEach((l)=>{ l.classList.remove('active') })
            link.classList.add('active');

            if(link.closest('.nav').previousElementSibling.classList.contains('ltp_f_navMob') && link.closest('.nav').previousElementSibling.classList.contains('open')) {
                link.closest('.nav').previousElementSibling.click()
            }
        })
    })

    if(location.hash.length !== 0 && document.querySelector('.nav [href="'+location.hash+'"]') !== null) {
        document.querySelector('.nav [href="'+location.hash+'"]').click()
    }
}

function initWow()
{
    new WOW(
        {
            animateClass: 'animate__animated', // default
        }
    ).init();
}
function modalsActions(dataModalsOpen, dataModalsClose) {
    dataModalsOpen.forEach((dataModalOpen)=>{
        dataModalOpen.addEventListener('click', ()=>{
            let modalTarget = dataModalOpen.dataset.modalOpen;
            let modal = document.querySelector(modalTarget);

            if(modal !== null) {
                if(!modal.classList.contains('open')) {
                    modal.classList.add('open');
                    document.querySelector('body').style.overflowY = 'hidden';
                }
            }
        })
    })

    if(dataModalsClose.length > 0) {
        dataModalsClose.forEach((dataModalClose)=>{
            dataModalClose.addEventListener('click', (e)=>{
                e.preventDefault();
                let modalTarget = dataModalClose.closest('.ltp_f_modal').id;
                let modal = document.querySelector('#'+modalTarget);

                if(modal !== null) {
                    if(modal.classList.contains('open')) {
                        modal.classList.remove('open');
                        document.querySelector('body').style.overflowY = 'initial';
                    }
                }
            })
        })
    }
}

function initLightGallery(buttonsLG)
{
    if(buttonsLG.length > 0) {
        buttonsLG.forEach((button, row)=>{
            const src = button.dataset.gallerySrc;
            const action = button.dataset.galleryAction;

            let datas = new FormData();
            datas.append('src', src)
            setAjax(action, datas).then((response)=>{
                let json = JSON.parse(response.response);
                if(json.status === 'success') {
                    let dynamicGallery = lightGallery(button, {
                        dynamic: true,
                        plugins: [lgZoom, lgVideo],
                        download:false,
                        dynamicEl: json.elements,

                    });
                    button.addEventListener('click', (e)=>{
                        e.preventDefault();
                        dynamicGallery.openGallery();
                    })
                }
            })
        })
    }
}

function initFormContact(buttonForm)
{
    if(buttonForm !== null) {
        buttonForm.addEventListener('click', (e)=>{
            e.preventDefault();
            console.log(buttonForm)
            buttonForm.setAttribute('type', 'button');
            buttonForm.style.cursor='wait';
            buttonForm.textContent = "En cours d'envoi";
            let form = buttonForm.closest('form');
            let action = form.getAttribute('action');
            let datas = new FormData(form);
            setAjax(action, datas).then((response)=>{
                let json = JSON.parse(response.response);
                if(form.querySelectorAll('.ltp_f_errors').length !== 0){
                    form.querySelectorAll('.ltp_f_errors').forEach((err)=>{err.remove()})
                }
                if(json.status === 'success') {
                    let section = document.querySelector('#'+json.target);
                    if(section!== null) {
                        section.querySelector('.ltp_f_confirm').style.display='block';
                        form.style.display='none';
                        buttonForm.setAttribute('type', 'submit');
                        buttonForm.style.cursor='default';
                        buttonForm.textContent = "Envoyer";
                    }
                }
                if(json.status === "error"){
                    let errorsMsg = json.errors;
                    Object.entries(errorsMsg).forEach(([key, msg])=>{
                        let inputHtml = form.querySelector('[name="'+key+'"]');
                        if(inputHtml !== null){
                            inputHtml.insertAdjacentHTML('afterend', `<div class="ltp_f_errors">${msg}</div>`);
                            buttonForm.setAttribute('type', 'submit');
                            buttonForm.style.cursor='default';
                            buttonForm.textContent = "Vérifier et Envoyer";
                        }
                    })
                }
            })
        })
    }
}

function wysiwygTransform(datasWysiwyg)
{
    datasWysiwyg.forEach((datasW)=>{
        let datasStyle = datasW.querySelectorAll('[style*="font-size"]');
        if(datasStyle.length !== 0) {
            datasStyle.forEach((dataS)=>{
                let size = dataS.style.fontSize;
                if(size.search('px') !== -1){
                    dataS.style.fontSize = parseInt(size.replace('px', '')) / 10 +'rem';
                }
            })
        }
    })
}

function scrollParallaxEffect(scrollParallaxBoxes) {
    scrollParallaxBoxes.forEach((scrollParallaxBox, key) => {
        new simpleParallax(scrollParallaxBox,
            {
                delay: .6,
                transition: 'cubic-bezier(.17,.67,.83,.67)',
                overflow : true,

            }
        );
    });
}

function mapInit(mapWrap){
    let mapId = mapWrap.getAttribute('id');
    let coordinates = JSON.parse(mapWrap.dataset.coordinates);

    mapboxgl.accessToken = 'pk.eyJ1IjoibHRwZGV2IiwiYSI6ImNsaWx3eWg2ZDB3anczZGtqazdmcDFwZncifQ.FabE3S4IhndVdboJxh3SOA';
    let map = new mapboxgl.Map({
        container: mapId,
        zoom:15,
        center:[coordinates.longitude, coordinates.latitude],
        style: 'mapbox://styles/mapbox/streets-v11',
        cooperativeGestures: true,
        locale: {
            "ScrollZoomBlocker.CtrlMessage": "Utilisez ctrl + scroll pour zoomer sur la carte.",
            "ScrollZoomBlocker.CmdMessage": "Utilisez ⌘ + scroll pour zoomer sur la carte.",
            "TouchPanBlocker.Message": "Utilisez deux doigts pour déplacer la carte.",
        },
    });
    map.addControl(new mapboxgl.NavigationControl());
    map.scrollZoom.disable();
    const holding = new mapboxgl.Marker()
        .setLngLat([coordinates.longitude, coordinates.latitude])
        .addTo(map);
}

function uploadFile(inputsfile) {
    inputsfile.forEach((inputFile) => {
        inputFile.addEventListener('change', () => {
            let files = inputFile.files;
            let target = inputFile.closest('.ltp_formFile').querySelector('.ltp_formInput');
            let defaultTargetText = target.dataset.default;

            let reader;
            let url;
            let maxS = 2*1024*1024;

            if(!files.length) {
                target.innerHTML = '<span class="ltp_f_errors">Aucun document sélectionné</span>'
                setTimeout(()=>{
                    target.innerHTML = defaultTargetText;
                }, 5000)
            } else {
                target.innerHTML = "";
                for (let i = 0; i<files.length; i++) {
                    if(files[i].size <= maxS) {
                        target.innerHTML = `<span>${files[i].name} (${formatBytes(files[i].size)})</span>`;
                    } else {
                        target.innerHTML = `<span class="ltp_f_errors">Document trop volumineux (${formatBytes(files[i].size)}). La limite est de ${formatBytes(maxS)}.</span>`;
                    }
                }
            }

        })
    })
}

function getHiddenProp(){
    let prefixes = ['webkit','moz','ms','o'];

    // if 'hidden' is natively supported just return it
    if ('hidden' in document) return 'hidden';

    // otherwise loop over all the known prefixes until we find one
    for (let i = 0; i < prefixes.length; i++){
        if ((prefixes[i] + 'Hidden') in document)
            return prefixes[i] + 'Hidden';
    }

    // otherwise it's not supported
    return null;
}
// use the property name to generate the prefixed event name
let visProp = getHiddenProp();
if (visProp) {
    let evtname = visProp.replace(/[H|h]idden/,'') + 'visibilitychange';
    document.addEventListener(evtname, visChange);
}
function isHidden() {
    let prop = getHiddenProp();
    if (!prop) return false;

    return document[prop];
}

function visChange() {
    if(document.querySelector('[name="previewTab"]') !== null){
        if (isHidden()) {
            if(document.querySelector('[name="previewTab"]') !== null) {
                window.close();
            }
        }
    }
}
visChange();

window.addEventListener('DOMContentLoaded', target => {

    const navMob = document.querySelector('.ltp_f_navMob');
    if(navMob !== null) {
        openNav(navMob)
    }

    const navLink = document.querySelectorAll('.nav a');
    if(navLink.length > 0 ) {
        navigateSite(navLink);
    }

    const dataModalsOpen = document.querySelectorAll('[data-modal-open]');
    const dataModalsClose = document.querySelectorAll('[data-modal-close]');
    const openAction = false;

    if(dataModalsOpen.length > 0) {
        modalsActions(dataModalsOpen, dataModalsClose, openAction)
    }

    const buttonsLightGallery = document.querySelectorAll('[data-gallery]');
    if(buttonsLightGallery.length > 0) {
        initLightGallery(buttonsLightGallery);
    }

    const buttonsForm = document.querySelectorAll('[data-contact]');
    if(buttonsForm.length > 0) {
        buttonsForm.forEach((buttonForm)=>{
            initFormContact(buttonForm);
        })
    }

    const datasWysiwyg = document.querySelectorAll('[data-wysiwyg]');
    if(datasWysiwyg.length > 0) {
        wysiwygTransform(datasWysiwyg);
    }

    const scrollParallaxBoxes = document.querySelectorAll('.scrollParallaxBox');
    if(scrollParallaxBoxes.length > 0) {
        scrollParallaxEffect(scrollParallaxBoxes);
    }

    let wowElements = document.querySelectorAll('.wow');
    if(wowElements.length > 0) {
        initWow();
        const wowObserver = new IntersectionObserver(wowCallback);
        wowElements.forEach((wowElement)=>{
            wowElement.style.animationFillMode = 'forwards';
            wowObserver.observe(wowElement);
        })
    }

    const mapWrap = document.querySelector('#ltp_f_map');
    if(mapWrap !== null) {
        setTimeout( ()=>{
            mapInit(mapWrap)
        },500)
    }

    const inputsFile = document.querySelectorAll('input[type="file"]');
    if(inputsFile.length > 0) {
        uploadFile(inputsFile)
    }

})

const wowCallback = entries => {
    entries.forEach((entry) => {
        if(entry.intersectionRatio > 0){
            reactivateWowAnimation(entry.target)
        } else {
            forceWowReanimation(entry.target)
        }
    });
}

function forceWowReanimation(element) {
    let classesIn = element.dataset.ltpAnimation;
    let classesOut = element.dataset.ltpAnimationOut;
    element.classList.remove(classesIn)
    element.classList.add(classesOut)
}
function reactivateWowAnimation(element){
    let classesIn = element.dataset.ltpAnimation;
    let classesOut = element.dataset.ltpAnimationOut;
    element.classList.remove(classesOut)
    element.classList.add(classesIn)
}
